export const countries = [
  {
    label: "Afghanistan",
    value: "Afghanistan"
  },
  {
    label: "Aland Islands",
    value: "Aland Islands"
  },
  {
    label: "Albania",
    value: "Albania"
  },
  {
    label: "Algeria",
    value: "Algeria"
  },
  {
    label: "American Samoa",
    value: "American Samoa"
  },
  {
    label: "Andorra",
    value: "Andorra"
  },
  {
    label: "Angola",
    value: "Angola"
  },
  {
    label: "Anguilla",
    value: "Anguilla"
  },
  {
    label: "Antarctica",
    value: "Antarctica"
  },
  {
    label: "Antigua and Barbuda",
    value: "Antigua and Barbuda"
  },
  {
    label: "Argentina",
    value: "Argentina"
  },
  {
    label: "Armenia",
    value: "Armenia"
  },
  {
    label: "Aruba",
    value: "Aruba"
  },
  {
    label: "Australia",
    value: "Australia"
  },
  {
    label: "Austria",
    value: "Austria"
  },
  {
    label: "Azerbaijan",
    value: "Azerbaijan"
  },
  {
    label: "Bahamas",
    value: "Bahamas"
  },
  {
    label: "Bahrain",
    value: "Bahrain"
  },
  {
    label: "Bangladesh",
    value: "Bangladesh"
  },
  {
    label: "Barbados",
    value: "Barbados"
  },
  {
    label: "Belarus",
    value: "Belarus"
  },
  {
    label: "Belgium",
    value: "Belgium"
  },
  {
    label: "Belize",
    value: "Belize"
  },
  {
    label: "Benin",
    value: "Benin"
  },
  {
    label: "Bermuda",
    value: "Bermuda"
  },
  {
    label: "Bhutan",
    value: "Bhutan"
  },
  {
    label: "Bolivia",
    value: "Bolivia"
  },
  {
    label: "Bonaire",
    value: "Bonaire"
  },
  {
    label: "Bosnia and Herzegovina",
    value: "Bosnia and Herzegovina"
  },
  {
    label: "Botswana",
    value: "Botswana"
  },
  {
    label: "Bouvet Island",
    value: "Bouvet Island"
  },
  {
    label: "Brazil",
    value: "Brazil"
  },
  {
    label: "Brunei Darussalam",
    value: "Brunei Darussalam"
  },
  {
    label: "Bulgaria",
    value: "Bulgaria"
  },
  {
    label: "Burkina Faso",
    value: "Burkina Faso"
  },
  {
    label: "Burundi",
    value: "Burundi"
  },
  {
    label: "Cabo Verde",
    value: "Cabo Verde"
  },
  {
    label: "Cambodia",
    value: "Cambodia"
  },
  {
    label: "Cameroon",
    value: "Cameroon"
  },
  {
    label: "Canada",
    value: "Canada"
  },
  {
    label: "Cayman Islands",
    value: "Cayman Islands"
  },
  {
    label: "Central African Republic",
    value: "Central African Republic"
  },
  {
    label: "Chad",
    value: "Chad"
  },
  {
    label: "Chile",
    value: "Chile"
  },
  {
    label: "China",
    value: "China"
  },
  {
    label: "Christmas Island",
    value: "Christmas Island"
  },
  {
    label: "Cocos Islands",
    value: "Cocos Islands"
  },
  {
    label: "Colombia",
    value: "Colombia"
  },
  {
    label: "Comoros",
    value: "Comoros"
  },
  {
    label: "Congo",
    value: "Congo"
  },
  {
    label: "Congo",
    value: "Congo"
  },
  {
    label: "Cook Islands",
    value: "Cook Islands"
  },
  {
    label: "Costa Rica",
    value: "Costa Rica"
  },
  {
    label: "Cote d'Ivoire",
    value: "Cote d'Ivoire"
  },
  {
    label: "Croatia",
    value: "Croatia"
  },
  {
    label: "Cuba",
    value: "Cuba"
  },
  {
    label: "Curacao",
    value: "Curacao"
  },
  {
    label: "Cyprus",
    value: "Cyprus"
  },
  {
    label: "Czech Republic",
    value: "Czech Republic"
  },
  {
    label: "Denmark",
    value: "Denmark"
  },
  {
    label: "Djibouti",
    value: "Djibouti"
  },
  {
    label: "Dominica",
    value: "Dominica"
  },
  {
    label: "Dominican Republic",
    value: "Dominican Republic"
  },
  {
    label: "Ecuador",
    value: "Ecuador"
  },
  {
    label: "Egypt",
    value: "Egypt"
  },
  {
    label: "El Salvador",
    value: "El Salvador"
  },
  {
    label: "Equatorial Guinea",
    value: "Equatorial Guinea"
  },
  {
    label: "Eritrea",
    value: "Eritrea"
  },
  {
    label: "Estonia",
    value: "Estonia"
  },
  {
    label: "Ethiopia",
    value: "Ethiopia"
  },
  {
    label: "Falkland Islands",
    value: "Falkland Islands"
  },
  {
    label: "Faroe Islands",
    value: "Faroe Islands"
  },
  {
    label: "Fiji",
    value: "Fiji"
  },
  {
    label: "Finland",
    value: "Finland"
  },
  {
    label: "France",
    value: "France"
  },
  {
    label: "French Guiana",
    value: "French Guiana"
  },
  {
    label: "French Polynesia",
    value: "French Polynesia"
  },
  {
    label: "French Southern Territories",
    value: "French Southern Territories"
  },
  {
    label: "Gabon",
    value: "Gabon"
  },
  {
    label: "Gambia",
    value: "Gambia"
  },
  {
    label: "Georgia",
    value: "Georgia"
  },
  {
    label: "Germany",
    value: "Germany"
  },
  {
    label: "Ghana",
    value: "Ghana"
  },
  {
    label: "Gibraltar",
    value: "Gibraltar"
  },
  {
    label: "Greece",
    value: "Greece"
  },
  {
    label: "Greenland",
    value: "Greenland"
  },
  {
    label: "Grenada",
    value: "Grenada"
  },
  {
    label: "Guadeloupe",
    value: "Guadeloupe"
  },
  {
    label: "Guam",
    value: "Guam"
  },
  {
    label: "Guatemala",
    value: "Guatemala"
  },
  {
    label: "Guernsey",
    value: "Guernsey"
  },
  {
    label: "Guinea",
    value: "Guinea"
  },
  {
    label: "Guinea-Bissau",
    value: "Guinea-Bissau"
  },
  {
    label: "Guyana",
    value: "Guyana"
  },
  {
    label: "Haiti",
    value: "Haiti"
  },
  {
    label: "Heard and McDonald Islands",
    value: "Heard and McDonald Islands"
  },
  {
    label: "Holy See",
    value: "Holy See"
  },
  {
    label: "Honduras",
    value: "Honduras"
  },
  {
    label: "Hong Kong",
    value: "Hong Kong"
  },
  {
    label: "Hungary",
    value: "Hungary"
  },
  {
    label: "Iceland",
    value: "Iceland"
  },
  {
    label: "India",
    value: "India"
  },
  {
    label: "Indonesia",
    value: "Indonesia"
  },
  {
    label: "Iran",
    value: "Iran"
  },
  {
    label: "Iraq",
    value: "Iraq"
  },
  {
    label: "Ireland",
    value: "Ireland"
  },
  {
    label: "Isle of Man",
    value: "Isle of Man"
  },
  {
    label: "Israel",
    value: "Israel"
  },
  {
    label: "Italy",
    value: "Italy"
  },
  {
    label: "Jamaica",
    value: "Jamaica"
  },
  {
    label: "Japan",
    value: "Japan"
  },
  {
    label: "Jersey",
    value: "Jersey"
  },
  {
    label: "Jordan",
    value: "Jordan"
  },
  {
    label: "Kazakhstan",
    value: "Kazakhstan"
  },
  {
    label: "Kenya",
    value: "Kenya"
  },
  {
    label: "Kiribati",
    value: "Kiribati"
  },
  {
    label: "Korea",
    value: "Korea"
  },
  {
    label: "Korea",
    value: "Korea"
  },
  {
    label: "Kuwait",
    value: "Kuwait"
  },
  {
    label: "Kyrgyzstan",
    value: "Kyrgyzstan"
  },
  {
    label: "Lao People's",
    value: "Lao People's"
  },
  {
    label: "Latvia",
    value: "Latvia"
  },
  {
    label: "Lebanon",
    value: "Lebanon"
  },
  {
    label: "Lesotho",
    value: "Lesotho"
  },
  {
    label: "Liberia",
    value: "Liberia"
  },
  {
    label: "Libya",
    value: "Libya"
  },
  {
    label: "Liechtenstein",
    value: "Liechtenstein"
  },
  {
    label: "Lithuania",
    value: "Lithuania"
  },
  {
    label: "Luxembourg",
    value: "Luxembourg"
  },
  {
    label: "Macao",
    value: "Macao"
  },
  {
    label: "Macedonia",
    value: "Macedonia"
  },
  {
    label: "Madagascar",
    value: "Madagascar"
  },
  {
    label: "Malawi",
    value: "Malawi"
  },
  {
    label: "Malaysia",
    value: "Malaysia"
  },
  {
    label: "Maldives",
    value: "Maldives"
  },
  {
    label: "Mali",
    value: "Mali"
  },
  {
    label: "Malta",
    value: "Malta"
  },
  {
    label: "Marshall Islands",
    value: "Marshall Islands"
  },
  {
    label: "Martinique",
    value: "Martinique"
  },
  {
    label: "Mauritania",
    value: "Mauritania"
  },
  {
    label: "Mauritius",
    value: "Mauritius"
  },
  {
    label: "Mayotte",
    value: "Mayotte"
  },
  {
    label: "Mexico",
    value: "Mexico"
  },
  {
    label: "Micronesia",
    value: "Micronesia"
  },
  {
    label: "Moldova",
    value: "Moldova"
  },
  {
    label: "Monaco",
    value: "Monaco"
  },
  {
    label: "Mongolia",
    value: "Mongolia"
  },
  {
    label: "Montenegro",
    value: "Montenegro"
  },
  {
    label: "Montserrat",
    value: "Montserrat"
  },
  {
    label: "Morocco",
    value: "Morocco"
  },
  {
    label: "Mozambique",
    value: "Mozambique"
  },
  {
    label: "Myanmar",
    value: "Myanmar"
  },
  {
    label: "Namibia",
    value: "Namibia"
  },
  {
    label: "Nauru",
    value: "Nauru"
  },
  {
    label: "Nepal",
    value: "Nepal"
  },
  {
    label: "Netherlands",
    value: "Netherlands"
  },
  {
    label: "New Caledonia",
    value: "New Caledonia"
  },
  {
    label: "New Zealand",
    value: "New Zealand"
  },
  {
    label: "Nicaragua",
    value: "Nicaragua"
  },
  {
    label: "Niger",
    value: "Niger"
  },
  {
    label: "Nigeria",
    value: "Nigeria"
  },
  {
    label: "Niue",
    value: "Niue"
  },
  {
    label: "Norfolk Island",
    value: "Norfolk Island"
  },
  {
    label: "Northern Mariana Islands",
    value: "Northern Mariana Islands"
  },
  {
    label: "Norway",
    value: "Norway"
  },
  {
    label: "Oman",
    value: "Oman"
  },
  {
    label: "Pakistan",
    value: "Pakistan"
  },
  {
    label: "Palau",
    value: "Palau"
  },
  {
    label: "Palestine",
    value: "Palestine"
  },
  {
    label: "Panama",
    value: "Panama"
  },
  {
    label: "Papua New Guinea",
    value: "Papua New Guinea"
  },
  {
    label: "Paraguay",
    value: "Paraguay"
  },
  {
    label: "Peru",
    value: "Peru"
  },
  {
    label: "Philippines",
    value: "Philippines"
  },
  {
    label: "Pitcairn",
    value: "Pitcairn"
  },
  {
    label: "Poland",
    value: "Poland"
  },
  {
    label: "Portugal",
    value: "Portugal"
  },
  {
    label: "Puerto Rico",
    value: "Puerto Rico"
  },
  {
    label: "Qatar",
    value: "Qatar"
  },
  {
    label: "Reunion",
    value: "Reunion"
  },
  {
    label: "Romania",
    value: "Romania"
  },
  {
    label: "Russian Federation",
    value: "Russian Federation"
  },
  {
    label: "Rwanda",
    value: "Rwanda"
  },
  {
    label: "Saint Barthelemy",
    value: "Saint Barthelemy"
  },
  {
    label: "Saint Helena",
    value: "Saint Helena"
  },
  {
    label: "Saint Kitts and Nevis",
    value: "Saint Kitts and Nevis"
  },
  {
    label: "Saint Lucia",
    value: "Saint Lucia"
  },
  {
    label: "Saint Martin",
    value: "Saint Martin"
  },
  {
    label: "Saint Pierre and Miquelon",
    value: "Saint Pierre and Miquelon"
  },
  {
    label: "Saint Vincent and the Grenadines",
    value: "Saint Vincent and the Grenadines"
  },
  {
    label: "Samoa",
    value: "Samoa"
  },
  {
    label: "San Marino",
    value: "San Marino"
  },
  {
    label: "Sao Tome and Principe",
    value: "Sao Tome and Principe"
  },
  {
    label: "Saudi Arabia",
    value: "Saudi Arabia"
  },
  {
    label: "Senegal",
    value: "Senegal"
  },
  {
    label: "Serbia",
    value: "Serbia"
  },
  {
    label: "Seychelles",
    value: "Seychelles"
  },
  {
    label: "Sierra Leone",
    value: "Sierra Leone"
  },
  {
    label: "Singapore",
    value: "Singapore"
  },
  {
    label: "Sint Maarten",
    value: "Sint Maarten"
  },
  {
    label: "Slovakia",
    value: "Slovakia"
  },
  {
    label: "Slovenia",
    value: "Slovenia"
  },
  {
    label: "Solomon Islands",
    value: "Solomon Islands"
  },
  {
    label: "Somalia",
    value: "Somalia"
  },
  {
    label: "South Africa",
    value: "South Africa"
  },
  {
    label: "South Georgia",
    value: "South Georgia"
  },
  {
    label: "South Sudan",
    value: "South Sudan"
  },
  {
    label: "Spain",
    value: "Spain"
  },
  {
    label: "Sri Lanka",
    value: "Sri Lanka"
  },
  {
    label: "Sudan",
    value: "Sudan"
  },
  {
    label: "Suriname",
    value: "Suriname"
  },
  {
    label: "Svalbard and Jan Mayen",
    value: "Svalbard and Jan Mayen"
  },
  {
    label: "Swaziland",
    value: "Swaziland"
  },
  {
    label: "Sweden",
    value: "Sweden"
  },
  {
    label: "Switzerland",
    value: "Switzerland"
  },
  {
    label: "Syrian Arab Republic",
    value: "Syrian Arab Republic"
  },
  {
    label: "Taiwan",
    value: "Taiwan"
  },
  {
    label: "Tajikistan",
    value: "Tajikistan"
  },
  {
    label: "Tanzania",
    value: "Tanzania"
  },
  {
    label: "Thailand",
    value: "Thailand"
  },
  {
    label: "Timor Leste",
    value: "Timor Leste"
  },
  {
    label: "Togo",
    value: "Togo"
  },
  {
    label: "Tokelau",
    value: "Tokelau"
  },
  {
    label: "Tonga",
    value: "Tonga"
  },
  {
    label: "Trinidad and Tobago",
    value: "Trinidad and Tobago"
  },
  {
    label: "Tunisia",
    value: "Tunisia"
  },
  {
    label: "Turvalue",
    value: "Turvalue"
  },
  {
    label: "Turkmenistan",
    value: "Turkmenistan"
  },
  {
    label: "Turks and Caicos Islands",
    value: "Turks and Caicos Islands"
  },
  {
    label: "Tuvalue",
    value: "Tuvalue"
  },
  {
    label: "Uganda",
    value: "Uganda"
  },
  {
    label: "Ukraine",
    value: "Ukraine"
  },
  {
    label: "United Arab Emirates",
    value: "United Arab Emirates"
  },
  {
    label: "United Kingdom",
    value: "United Kingdom"
  },
  {
    label: "United States of America",
    value: "United States of America"
  },
  {
    label: "Uruguay",
    value: "Uruguay"
  },
  {
    label: "Uzbekistan",
    value: "Uzbekistan"
  },
  {
    label: "Vanuatu",
    value: "Vanuatu"
  },
  {
    label: "Venezuela",
    value: "Venezuela"
  },
  {
    label: "Viet Nam",
    value: "Viet Nam"
  },
  {
    label: "Virgin Islands",
    value: "Virgin Islands"
  },
  {
    label: "Virgin Islands",
    value: "Virgin Islands"
  },
  {
    label: "Wallis and Futuna",
    value: "Wallis and Futuna"
  },
  {
    label: "Western Sahara",
    value: "Western Sahara"
  },
  {
    label: "Yemen",
    value: "Yemen"
  },
  {
    label: "Zambia",
    value: "Zambia"
  },
  {
    label: "Zimbabwe",
    value: "Zimbabwe"
  }
];

export const city = [
  { value: "Amherstburg", label: "Amherstburg" },
  { value: "Leamington", label: "Leamington" },
  { value: "Essex", label: "Essex" },
  { value: "Kingsville", label: "Kingsville" },
  { value: "Tecumseh", label: "Tecumseh" },
  { value: "Lakeshore", label: "Lakeshore" },
  { value: "Windsor", label: "Windsor" },
  { value: "LaSalle", label: "LaSalle" }
];

export const employeesAtCurrentLocation = [
  {
    value: "1 to 4",
    label: "1 to 4"
  },
  {
    value: "5 to 9",
    label: "5 to 9"
  },
  {
    value: "10 to 19",
    label: "10 to 19"
  },
  {
    value: "20 to 49",
    label: "20 to 49"
  },
  {
    value: "50 to 99",
    label: "50 to 99"
  },
  {
    value: "100 to 199",
    label: "100 to 199"
  },
  {
    value: "200 to 499",
    label: "200 to 499"
  },
  {
    value: "500+",
    label: "500+"
  }
];

export const companiesSector = [
  {
    value: "Advanced manufacturing - Automation",
    label: "Advanced manufacturing - Automation"
  },
  {
    value: "Advanced manufacturing - Automotive parts",
    label: "Advanced manufacturing - Automotive parts"
  },
  {
    value: "Advanced manufacturing - Food processing",
    label: "Advanced manufacturing - Food processing"
  },
  {
    value: "Advanced manufacturing - Machine, tool, die and mold",
    label: "Advanced manufacturing - Machine, tool, die and mold"
  },
  {
    value: "Advanced manufacturing - Fabrication",
    label: "Advanced manufacturing - Fabrication"
  },
  {
    value: "Advanced manufacturing - Other",
    label: "Advanced manufacturing - Other"
  },
  {
    value: "Agribusiness",
    label: "Agribusiness"
  },
  {
    value: "ICT",
    label: "ICT"
  },
  {
    value: "Health and pharmaceutical",
    label: "Health and pharmaceutical"
  },
  {
    value: "Professional services and back office operations",
    label: "Professional services and back office operations"
  },
  {
    value: "Logistics and transportation",
    label: "Logistics and transportation"
  },
  {
    value: "Warehousing and distribution",
    label: "Warehousing and distribution"
  },
  {
    value: "Other",
    label: "Other"
  }
];

export const industriesSupplied = [
  {
    value: "Aerospace/Defense",
    label: "Aerospace/Defense"
  },
  {
    value: "Agriculture/Agri-business",
    label: "Agriculture/Agri-business"
  },
  {
    value: "Automotive ",
    label: "Automotive "
  },
  {
    value: "Construction",
    label: "Construction"
  },
  {
    value: "Computer/business equipment",
    label: "Computer/business equipment"
  },
  {
    value: "Consumer goods",
    label: "Consumer goods"
  },
  {
    value: "Energy",
    label: "Energy"
  },
  {
    value: "Financial",
    label: "Financial"
  },
  {
    value: "Food processing ",
    label: "Food processing "
  },
  {
    value: "Industrial",
    label: "Industrial"
  },
  {
    value: "Lawn/garden",
    label: "Lawn/garden"
  },
  {
    value: "Lighting",
    label: "Lighting"
  },
  {
    value: "Machinery and equipment",
    label: "Machinery and equipment"
  },
  {
    value: "Medical/optical/dental",
    label: "Medical/optical/dental"
  },
  {
    value: "Oil and gas",
    label: "Oil and gas"
  },
  {
    value: "Packaging",
    label: "Packaging"
  },
  {
    value: "Pharmaceutical/nutraceutical",
    label: "Pharmaceutical/nutraceutical"
  },
  {
    value: "Recreational vehicles",
    label: "Recreational vehicles"
  },
  {
    value: "Renewable energy",
    label: "Renewable energy"
  },
  {
    value: "Transportation non-automotive",
    label: "Transportation non-automotive"
  },
  {
    value: "Other",
    label: "Other"
  }
];

export const certification = [
  {
    value: "ISO 9001:2008",
    label: "ISO 9001:2008"
  },
  {
    value: "ISO 9001:2015",
    label: "ISO 9001:2015"
  },
  {
    value: "ISO 17025",
    label: "ISO 17025"
  },
  {
    value: "ISO/TS 16949:2002",
    label: "ISO/TS 16949:2002"
  },
  {
    value: "ISO/TS 16949:2009",
    label: "ISO/TS 16949:2009"
  },
  {
    value: "ISO 14001",
    label: "ISO 14001"
  },
  {
    value: "ISO 13485",
    label: "ISO 13485"
  },
  {
    value: "QS 9000",
    label: "QS 9000"
  },
  {
    value: "GP-11",
    label: "GP-11"
  },
  {
    value: "AS9001",
    label: "AS9001"
  },
  {
    value: "ISO/IEC 17025 ",
    label: "ISO/IEC 17025 "
  },
  {
    value: "ASQR 2673",
    label: "ASQR 2673"
  },
  {
    value: "CSA",
    label: "CSA"
  },
  {
    value: "ESA",
    label: "ESA"
  },
  {
    value: "TSSA",
    label: "TSSA"
  },
  {
    value: "Ford Q1",
    label: "Ford Q1"
  },
  {
    value: "Controlled Goods Program (CGP)",
    label: "Controlled Goods Program (CGP)"
  },
  {
    value: "Advanced Quality Control Planning (AQCP)",
    label: "Advanced Quality Control Planning (AQCP)"
  },
  {
    value: "Customs Trade Partnership Again Terrorism (C-TPAT)",
    label: "Customs Trade Partnership Again Terrorism (C-TPAT)"
  },
  {
    value: "Automated Commercial Environment (ACE)",
    label: "Automated Commercial Environment (ACE)"
  },
  {
    value: "Free and Secure Trade (F.A.S.T)",
    label: "Free and Secure Trade (F.A.S.T)"
  },
  {
    value: "Customs Self-Assessment Program (CSA)",
    label: "Customs Self-Assessment Program (CSA)"
  },
  {
    value: "Canadian Bonded Highway Carrier Bond",
    label: "Canadian Bonded Highway Carrier Bond"
  },
  {
    value: "USA Bonded Highway Carrier Bond",
    label: "USA Bonded Highway Carrier Bond"
  },
  {
    value: "Standard Carrier Alpha Code (SCAC)",
    label: "Standard Carrier Alpha Code (SCAC)"
  },
  {
    value: "MC Certificate",
    label: "MC Certificate"
  },
  {
    value: "CSI Organic",
    label: "CSI Organic"
  },
  {
    value: "Other",
    label: "Other"
  }
];

export const businessLeadership = [
  {
    label: "Francophone",
    value: "Francophone"
  },
  {
    label: "Indigenous",
    value: "Indigenous"
  },
  {
    label: "LGBTQ+",
    value: "LGBTQ+"
  },
  {
    label: "Newcomer",
    value: "Newcomer"
  },
  {
    label: "Persons with disabilities",
    value: "Persons with disabilities"
  },
  {
    label: "Visible minorities",
    value: "Visible minorities"
  },
  {
    label: "Women-led",
    value: "Women-led"
  },
  {
    label: "Women-owned",
    value: "Women-owned"
  },
  {
    label: "Youth",
    value: "Youth"
  },
  {
    label: "Other",
    value: "Other"
  }
];

export const governmentSupplier = [
  {
    label: "Municipal",
    value: "Municipal"
  },
  {
    label: "Provincial",
    value: "Provincial"
  },
  {
    label: "Federal",
    value: "Federal"
  }
];

export const exportMarkets = [
  { value: "USA", label: "USA" },
  { value: "Mexico", label: "Mexico" },
  { value: "South America - Brazil", label: "South America - Brazil" },
  {
    value: "South America - Other South America",
    label: "South America - Other South America"
  },
  { value: "Europe - UK", label: "Europe - UK" },
  { value: "Europe - Germany", label: "Europe - Germany" },
  { value: "Europe - France", label: "Europe - France" },
  { value: "Europe - Spain", label: "Europe - Spain" },
  { value: "Europe - Portugal", label: "Europe - Portugal" },
  {
    value: "Europe - Other Western Europe",
    label: "Europe - Other Western Europe"
  },
  { value: "Europe - Eastern Europe", label: "Europe - Eastern Europe" },
  { value: "Asia - China", label: "Asia - China" },
  { value: "Asia - Japan", label: "Asia - Japan" },
  { value: "Asia - India", label: "Asia - India" },
  { value: "Asia - South Korea", label: "Asia - South Korea" },
  { value: "Asia - Other Asia", label: "Asia - Other Asia" },
  { value: "Australia", label: "Australia" },
  { value: "Middle East - Israel", label: "Middle East - Israel" },
  { value: "Middle East - Egypt", label: "Middle East - Egypt" },
  { value: "Middle East - Saudi Arabia", label: "Middle East - Saudi Arabia" },
  { value: "Middle East - Turkey", label: "Middle East - Turkey" },
  {
    value: "Middle East - Other Middle East",
    label: "Middle East - Other Middle East"
  },
  { value: "Africa", label: "Africa" },
  { value: "Global", label: "Global" }
];

export const industriesAffliation = [
  {
    value: "APMA",
    label: "APMA"
  },
  {
    value: "Automate Canada",
    label: "Automate Canada"
  },
  {
    value: "CAMM",
    label: "CAMM"
  },
  {
    value: "CME",
    label: "CME"
  },
  {
    value: "CTMA",
    label: "CTMA"
  },
  {
    value: "EMC",
    label: "EMC"
  },
  {
    value: "Heavy Construction Association of Windsor",
    label: "Heavy Construction Association of Windsor"
  },
  {
    value: "OGVG",
    label: "OGVG"
  },
  {
    value: "Windsor Construction Association",
    label: "Windsor Construction Association"
  },
  {
    value: "WindsorEssex Regional Chamber of Commerce",
    label: "WindsorEssex Regional Chamber of Commerce"
  },
  {
    value: "Windsor Transportation Club",
    label: "Windsor Transportation Club"
  },
  {
    value: "Other",
    label: "Other"
  }
];

export const revenue = [
  {
    value: "$0-$500,000",
    label: "$0-$500,000"
  },
  {
    value: "$500,000-$1,000,000",
    label: "$500,000-$1,000,000"
  },
  {
    value: "$1,000,000-$2,000,000",
    label: "$1,000,000-$2,000,000"
  },
  {
    value: "$2,000,000-$5,000,000",
    label: "$2,000,000-$5,000,000"
  },
  {
    value: "$5,000,000-$10,000,000",
    label: "$5,000,000-$10,000,000"
  },
  { value: "$10,000,000-$20,000,000", label: "$10,000,000-$20,000,000" },
  { value: "$20,000,000-$50,000,000", label: "$20,000,000-$50,000,000" },
  { value: "$50,000,000-$100,000,000", label: "$50,000,000-$100,000,000" },
  { value: "Over $100,000,000", label: "Over $100,000,000" }
];

export const activeNonActive = [
  {
    value: "Active",
    label: "Active"
  },
  {
    value: "InActive",
    label: "InActive"
  }
];

export const materialCapabilites = [
  {
    value: "Alloys",
    label: "Alloys"
  },
  {
    value: "Aluminum",
    label: "Aluminum"
  },
  {
    value: "Carbon fibre",
    label: "Carbon fibre"
  },
  {
    value: "Cobalt",
    label: "Cobalt"
  },
  {
    value: "Exotic metals",
    label: "Exotic metals"
  },
  {
    value: "Inconel",
    label: "Inconel"
  },
  {
    value: "Plastics",
    label: "Plastics"
  },
  {
    value: "Resins",
    label: "Resins"
  },
  {
    value: "Stainless",
    label: "Stainless"
  },
  {
    value: "Steels",
    label: "Steels"
  },
  {
    value: "Titanium",
    label: "Titanium"
  },
  {
    value: "Tungsten",
    label: "Tungsten"
  },
  {
    value: "Other",
    label: "Other"
  }
];

export const headQuarterBranch = [
  { value: "Headquarters", label: "Headquarters" },
  { value: "Branch", label: "Branch" }
];
